import type { FunctionComponent } from "react";
import { Link } from "react-router-dom";

import { DateTime } from "luxon";
import {
  PostStatus,
  type IPost,
} from "../../../types/models/post.models.types";
import RejectionCard from "../../../components/rejection-card.components";
import { AccountType } from "../../../constants/account-types.constants";
import Button from "./button.core";
import { Post } from "./post.core";
import { PostAction } from "./post-action.core";
import RightArrowIcon from "../../assets/svgs/right-arrow.svg";

type AppProps = {
  post: IPost;
};

export const CampaignPost: FunctionComponent<AppProps> = ({ post }) => {
  function handlePostStatus() {
    if (post.postStatus.status === PostStatus.postApproved) {
      return "Live post";
    }
    if (post.postStatus.status === PostStatus.flagged) {
      return "Live posts: flagged";
    }
    if (post.postStatus.status === PostStatus.flaggedReview) {
      return "Live posts: flagged review";
    }
    if (post.postStatus.status === PostStatus.disqualify) {
      return "Live posts: disqualified";
    }
    if (post.postStatus.status === PostStatus.post) {
      return "Post submission: pending";
    }
    if (post.postStatus.status === PostStatus.postRejected) {
      return "Post submission: rejected";
    }
    if (post.postStatus.status === PostStatus.draft) {
      return "Draft submission: pending";
    }
    if (post.postStatus.status === PostStatus.draftApproved) {
      return "Draft submission: approved";
    }
    if (post.postStatus.status === PostStatus.draftRejected) {
      return "Draft submission: rejected";
    }
    return "";
  }

  return (
    <div className="flex flex-col gap-4 w-full font-cabinetgrotesk">
      <div
        className={
          "flex flex-col justify-between items-center   rounded-lg w-full font-semibold "
        }
      >
        {post.hasUserDeletedPost &&
          (post.postStatus.status === PostStatus.postApproved ||
            post.postStatus.status === PostStatus.flagged ||
            post.postStatus.status === PostStatus.flaggedReview ||
            post.postStatus.status === PostStatus.disqualify) && (
            <RejectionCard
              title="Post deleted"
              message="The user might have deleted the post, please verify on instagram before taking action."
              status="postDeleted"
            />
          )}
        <Link className="w-full" to={`${location.pathname}/${post.id}`}>
          <div
            className={`flex justify-between items-center px-4 py-3 border w-full ${
              (post.hasUserDeletedPost &&
                (post.postStatus.status === PostStatus.postApproved ||
                  post.postStatus.status === PostStatus.flagged ||
                  post.postStatus.status === PostStatus.flaggedReview ||
                  post.postStatus.status === PostStatus.disqualify)) ||
              (post.autoReviewStatus &&
                post.postStatus.status === PostStatus.post)
                ? "rounded-b-lg border-t-0"
                : "rounded-lg"
            }`}
          >
            <span className="text-xs">Show more details</span>
            <div className="flex items-center gap-4">
              <RightArrowIcon />
            </div>
          </div>
        </Link>
      </div>
      {post.postStatus.status === "flagged" && (
        <div className="flex items-start gap-1 px-3 py-4 border rounded-lg font-semibold text-secondary">
          Reason:
          <span className="max-h-12 text-black text-wrap truncate">
            {post.postStatus.message}
          </span>
        </div>
      )}
      <div className="flex flex-col border rounded-lg w-full overflow-hidden">
        <div
          className={`relative flex justify-between items-center px-4 ${post.postStatus.status === PostStatus.postApproved ? "pt-8" : "pt-4"}  w-full`}
        >
          {(post.postStatus.status === PostStatus.postApproved ||
            post.postStatus.status === PostStatus.vendorDraft) &&
          post.addedByUser?.accountType === AccountType.ADMIN ? (
            <div className="top-0 left-0 absolute bg-primarybuttonbg px-2 py-1 rounded-br-10 font-semibold text-black text-xs">
              added by {post.addedByUser.email}
            </div>
          ) : (
            ""
          )}
          <div className="flex flex-col font-semibold text-left">
            <p className="text-base">
              {post.creator?.name}
            </p>
            {post.postStatus.status === PostStatus.draft ? (
              <span className="text-secondary text-xs">
                Submitted on{" "}
                {DateTime.fromISO(
                  new Date(post.postStatus.timestamp).toISOString(),
                ).toRelative()}
              </span>
            ) : (
              <span className="text-secondary text-xs">
                {DateTime.fromISO(
                  new Date(post.postStatus.timestamp).toISOString(),
                ).toRelative()}
              </span>
            )}
          </div>
          <Link
            target="_blank"
            to={`https://instagram.com/${post.social?.handle}`}
          >
            <Button
              variant="secondary"
              className="px-4 py-2 font-semibold text-sm"
            >
              View profile
            </Button>
          </Link>
        </div>
        <div className="py-3 p-2">
          <Button
            className={`bg-tertiarybuttonbg px-4 border border-border tracking-wide h-8 font-semibold text-xs ${window.location.pathname.includes("search") ? "flex" : "hidden"}`}
          >
            {handlePostStatus()}
          </Button>
        </div>
        <Post post={post} />
      </div>

      <PostAction post={post} />
    </div>
  );
};
